<div class="text-center" *hasPermission="permissionTypes.ModifyLotteryLicence">
  <button mat-icon-button
          (click)="onEditLotteryLicence()"
          data-testid="edit-licence-button">
    <mat-icon matTooltipPosition="right"
              matTooltip="edit licence number data"
    >edit
    </mat-icon>
  </button>
</div>
